// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"539":"e233fe23","869":"0fdc2cc4"}[chunkId] + ".chunk.js";
};